const domainList = require("./domainList.json");
export default domainList;
// export const defaultDomain = domainList[0]
